import React from "react";
import "./Email.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Email() {
  
  const notify = () => toast("Thank you for your attention", {
    theme: "light",

  });

   const formBtn = (e) => {
    e.preventDefault();
    let botMessege = `
    Hi, New Message!😊%0A
      Message ☎: ${e.target[0].value}%0A`;
 
    let url = `https://api.telegram.org/bot5684293878:AAG-90_ad15A3RYCIUgPstvo6NEc3gIIXEQ/sendMessage?chat_id=-1001738516733&text=${botMessege}`;
     async function fetchAsync(url) {
      let response = await fetch(url);
       let data = await response.json();
       return data;
    }
    fetchAsync(url);
    e.target[0].value = ""
 
  };


  return (
    <div className="email" id="contact">
              <ToastContainer />

      <div className="container">
        <h2 className="email-title">
          Subscribe to our newsletter & We’ll give you even more to Love
        </h2>
        <p className="email-text">
          To receive exclusive offers, updates and more.
        </p>
        <form className="email-form" onSubmit={formBtn}>
          <input
            type="email"
            placeholder="Email"
            required
            className="email-input"
          />
          <button type="submit" onClick={notify} className="email-btn">
            Sign up
          </button>
        </form>
      </div>
    </div>
  );
}
